import type { AuthDto } from '@mathflat/domain/@entities/Auth'

import { LOGIN_API_URLS, mpEventInfo } from '@/constant'
import maxios from '@/utils/axios/maxios'

/***
 * @see res.Auth
 * @see AuthController
 ***/

// 인증 API
const authApi = {
  // 로그인
  postLogin(data: AuthDto.LoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>('/v2/login', data)
  },

  postNaverWorksLogin(data: AuthDto.NaverWorksLoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>('/v2/login/oauth2/naver-works', data)
  },

  postAiepLogin(payload: AuthDto.AiepLoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>(LOGIN_API_URLS.AIEP_LOGIN, payload)
  },

  postWeizmannLogin(data: AuthDto.WeizmannLoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>('/v2/login/oauth2/weizmann-legacy', data)
  },

  postWeizmannOauth2Login(data: AuthDto.WeizmannOauth2LoginRequestDto) {
    return maxios.post<AuthDto.LoginResponseDto>('/v2/login/oauth2/weizmann', data)
  },

  postLogout(data: AuthDto.LogoutRequestDto) {
    return maxios.post('/v2/logout', data)
  },

  postLegacyLogout({ legacyToken }: AuthDto.LegacyLogoutRequestDto) {
    return maxios.post(
      '/logout',
      {},
      {
        params: { mp_event_name: mpEventInfo.로그아웃 },
        headers: {
          'x-auth-token': legacyToken,
        },
      },
    )
  },

  // 선생님앱에서 학생앱 로그인시 임시 인증 토큰 발급
  postStudentImpersonationAuthToken(data: AuthDto.StudentImpersonationAuthTokenRequestDto) {
    return maxios.post<AuthDto.StudentImpersonationAuthTokenResponseDto>(
      '/v2/student-impersonation-auth-token',
      data,
    )
  },

  // 비밀번호 재설정 (1단계)
  postResetToken(data: req.FindPasswordFirstStep) {
    return maxios.post('/password/reset-token', data, {
      params: { mp_event_name: mpEventInfo.비번재설정1 },
    })
  },
  // 비밀번호 재설정 (2단계)
  getCheckResetToken(params: req.FindPasswordSecondStep) {
    return maxios.get('/password/check-reset-token', {
      params: { ...params, mp_event_name: mpEventInfo.비번재설정2 },
    })
  },
  // 비밀번호 재설정 (3단계)
  patchCheckResetToken(data: req.FindPasswordThirdStep) {
    return maxios.patch('/password/with-reset-token', data, {
      params: { mp_event_name: mpEventInfo.비번재설정3 },
    })
  },
  // 이미 로그인한 경우 패스워드 변경 (v2 — 다른 세션 자동 무효화)
  postPassword(data: req.ResetPassword) {
    return maxios.post('/v2/password', data, {
      params: { mp_event_name: mpEventInfo.비번수정 },
    })
  },
  // 기관 소유의 학생, 학부모, 선생님 비밀번호 변경
  patchPassword(data: req.ModifyAppPassword) {
    return maxios.patch('/password', data, {
      params: { mp_event_name: mpEventInfo.학생학부모비번수정 },
    })
  },
  // 서비스 이용 동의
  postAllowServiceType(data: { serviceType: string }) {
    return maxios.post('/teachers/service-types/access', data)
  },
}
export default authApi
